import PropTypes from 'prop-types';
import React from 'react';
import { EmitMetric } from '../../../components/Analytics/VisibilityPixel/VisibilityPixel';
import UnderlineNavigation from '../../../components/Elements/UnderlineNavigation/UnderlineNavigation';
import Button from '../../../components/Input/Button/Button';
import Layout from '../../../components/Layout/Layout';
import PageSection from '../../../components/Layout/PageSection/PageSection';
import LeftRailContent from '../../../components/LeftRailLayout/LeftRailContent/LeftRailContent';
import LeftRailLayout from '../../../components/LeftRailLayout/LeftRailLayout';
import TopCompanies from '../../../components/Ratings/TopCompanies/TopCompanies';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
    PAGE_TABS,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';
import { PAGE_PROPS as DEFAULT_PAGE_PROPS } from '../../defaultProps';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import { getCloudinaryImagePathById } from '../../../utilities/images';

import './TopCompaniesV2.scss';

export default class TopCompaniesV2 extends React.PureComponent {
    sendEmployerClickMetric = () => {
        EmitMetric({
            misc_event_type: 'top-companies-employer-page-click',
            misc_event_count: 1,
        });
    };

    renderLeaveARievewBtn = () => {
        return (
            <PageConsumer>
                {(pageContext) => (
                    <Button
                        onClick={() => pageContext.toggleJobReviewSurvey(true)}
                        type="purple-medium-white"
                        value="Leave a review"
                        class="d-flex justify-content-center review-btn-wrapper"
                        inputStyle="review-btn"
                    />
                )}
            </PageConsumer>
        );
    };

    renderSubNav = () => {
        if (this.props.menuItems.length > 0) {
            const newSubNav =
                this.props.menuItems.length === 6 ? 'width400' : '';
            return (
                <div className={`subnav-container ${newSubNav}`}>
                    <UnderlineNavigation menuItems={this.props.menuItems} />
                </div>
            );
        }
    };

    getActiveTab = () => {
        const tabText = this.props.menuItems.filter((mI) => mI.active).pop()
            ?.text;
        let activeTab;

        switch (tabText) {
            case 'Best Company':
                activeTab = PAGE_TABS.BEST_COMPANY;
                break;
            case 'Best Company CEOs':
                activeTab = PAGE_TABS.BEST_CEO;
                break;
            case 'Best Consulting':
                activeTab = PAGE_TABS.BEST_CONSULTING;
                break;
            case 'Best Finance':
                activeTab = PAGE_TABS.BEST_FINANCE;
                break;
            case 'Best Tech':
                activeTab = PAGE_TABS.BEST_TECH;
                break;
            case 'Best Manager':
                activeTab = PAGE_TABS.BEST_MANANGER;
                break;
            case 'Best Flexibility':
                activeTab = PAGE_TABS.BEST_FLEXIBILITY;
                break;
            default:
                activeTab = null;
        }

        return activeTab;
    };

    render() {
        const { PAGE_PROPS, rowRecords, badge } = this.props;
        const { headerProps, footerProps, socialLikes } = PAGE_PROPS;
        const LayoutProps = {
            PAGE_PROPS,
            headerProps,
            footerProps,
            socialLikes,
        };

        const imageSrc = getCloudinaryImagePathById(badge, 'bestCompany', {
            bestCompany: 'c_scale,f_auto,q_auto,w_130',
        });

        return (
            <div className="page-Ratings-TopCompaniesV2">
                <SnowplowPageViewTracker
                    pageType={PAGE_VIEW_TYPES.LANDING_PAGE}
                    pageSection={PAGE_VIEW_SECTIONS.COMPANY_REVIEWS}
                    pageTab={this.getActiveTab()}
                />
                <Layout {...LayoutProps}>
                    <PageSection
                        header={
                            <h1 className="company-header-title">
                                {this.props.title}
                            </h1>
                        }
                    >
                        <LeftRailLayout>
                            <LeftRailLayout.LeftRail>
                                <div className="current-best-company-badge">
                                    <img
                                        src={imageSrc}
                                        alt="best company badge"
                                    />
                                </div>
                                <LeftRailContent {...PAGE_PROPS.leftRail} />
                            </LeftRailLayout.LeftRail>

                            <LeftRailLayout.MainContent>
                                <section className="section-top">
                                    {this.renderSubNav()}
                                    <div className="current-best-company-badge-mobile d-block d-md-none">
                                        <img
                                            src={imageSrc}
                                            alt="best company badge"
                                        />
                                    </div>
                                    <aside>
                                        <p>
                                            <span className="bold">
                                                This list runs on reviews.
                                            </span>{' '}
                                            If you feel your company should be
                                            included or ranked differently,
                                            please leave a review or invite your
                                            colleagues to weigh in!
                                        </p>
                                    </aside>
                                    {this.renderLeaveARievewBtn()}
                                </section>

                                <TopCompanies topCompanies={rowRecords} />

                                <aside className="section-methodology">
                                    <p>
                                        {this.props.methodologyText ||
                                            "Methodology: These lists are determined by anonymous reviews left on Fairygodboss. Scores may range from 0-100. Fairygodboss is averaging female employees' responses to 3 questions about their overall job satisfaction, perceived gender equality at work, and recommendations to other women about working at their employer, respectively. If you feel your company should be included or ranked differently, please leave a review or invite your colleagues to weigh in!"}
                                    </p>
                                </aside>

                                <section className="section-bottom">
                                    <h3 className="article-big">
                                        Think your company should be on the
                                        list?
                                    </h3>
                                    <p className="article-small">
                                        Contact us to learn more
                                    </p>
                                    <a
                                        onClick={this.sendEmployerClickMetric}
                                        href="/employers"
                                        className="page-Ratings-TopCompaniesV2__claim-cta"
                                    >
                                        Learn more
                                    </a>
                                </section>
                            </LeftRailLayout.MainContent>
                        </LeftRailLayout>
                    </PageSection>
                </Layout>
            </div>
        );
    }
}

TopCompaniesV2.propTypes = {
    title: PropTypes.string.isRequired,
    excerptType: PropTypes.oneOf(['daily', 'frozen']).isRequired,
    rowRecords: PropTypes.arrayOf(
        PropTypes.shape({
            position: PropTypes.string,
            average: PropTypes.number,
            logo: PropTypes.shape({
                src: PropTypes.string,
                alt: PropTypes.number,
            }),
            companyId: PropTypes.number,
            companyName: PropTypes.string,
            companyUrl: PropTypes.string,
            isFollowed: PropTypes.bool,
        })
    ).isRequired,
    badge: PropTypes.string.isRequired,
    PAGE_PROPS: DEFAULT_PAGE_PROPS.isRequired,
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
            active: PropTypes.bool,
        })
    ),
    methodologyText: PropTypes.string,
};

TopCompaniesV2.defaultProps = {
    menuItems: [],
    methodologyText: null,
};
